import Log from '../_Utility/Log';
import ReView from '../ReView';

class MonthPicker {

    /**
     * @since 2.14.0
     * @method constructor
     * @param string view is the view to refresh
     * @param bool run is a flag indicating immediate run
     */
    constructor(view, run) {
        // Set up variables
        this.selector = 'calendar-month-picker-input';

        // Run initialization
        this.init()
    }

    /**
     * Initialize the class.
     *
     * @since 2.14.0
     * @method init
     * @return void
     */
    init() {
        // Let them know we made it here OK
        new Log('MonthPicker initialized.', 'init');

        // Run it
        this.run();
    }

    /**
     * Run the view refresh.
     *
     * @since 2.14.0
     * @method run
     * @return void
     */
    run() {
        // Hover multi-day events at the same time
        $('.calendar').on('mouseover mouseout', '.is-multiday',
            function (e) {
                // Declare and initialize
                let event_id   = $(this).data('event-id');
                let occurrence = $(this).data('occurrence');

                // Hover everything
                $('.calendar').find(
                        '[data-event-id=\"' + event_id + '\"]' +
                        '[data-occurrence=\"' + occurrence + '\"] ' +
                        'a')
                    .toggleClass('hover');
            }
        );

        // Handle redirect on date select
        const monthPicker = document.getElementById(this.selector);

        // If we had none, just leave
        if (!monthPicker)
            return;

        // Listen for changes
        monthPicker.addEventListener('change', function () {
            let value      = this.value.split('-');
            let year       = value[0];
            let month      = value[1];
            let currentUrl = window.location.href;
            let domain     = currentUrl.split('/events')[0] + '/events/';

            // Set up the url
            let url = domain + 'month/' + year + '-' + month + '/';
            //new ReView('events/archive/index', true);

            // Run the redirect
            window.location.href = url;
        });

    }

}

export default MonthPicker;